import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import DynamicIcon from "@/components/ui/dynamic-icon";
import { cdn } from "@/lib/cdn";
import Link from "next/link";

interface PreFooterProps {
  className?: string;
}

const PreFooter = ({ className }: PreFooterProps) => {
  return (
    <div className={cn("grid grid-cols-1 items-center gap-8 bg-neutral-50 px-4 py-8 sm:px-8 lg:grid-cols-2 lg:gap-12 lg:p-0 lg:pl-16", className)}>
      <div className="flex flex-col gap-6 py-16">
        <p className="text-sm font-medium text-primary">
          Ready to get started?
        </p>
        <h2 className="text-3xl font-medium text-neutral-900 text-balance leading-tight lg:text-5xl">
          Turn your next presentation into an interactive handout
        </h2>
        <p className="text-base text-muted-foreground leading-relaxed max-w-lg">
          Upload your slides, let AI transform them into a mobile-optimized
          handout, and share it with your audience via QR code — at about ten
          seconds a slide.
        </p>

        <div className="flex flex-col gap-3 mt-2">
          <div className="flex items-center gap-3 text-sm text-neutral-600">
            <DynamicIcon name="upload" className="w-4 h-4 text-primary" />
            <span>Supports PPTX and PDF uploads</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-neutral-600">
            <DynamicIcon name="brain-circuit" className="w-4 h-4 text-primary" />
            <span>AI-powered charts, summaries &amp; modules</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-neutral-600">
            <DynamicIcon name="qr-code" className="w-4 h-4 text-primary" />
            <span>Instant sharing via QR code</span>
          </div>
        </div>

        <div className="flex flex-col items-start gap-4 mt-4 lg:flex-row">
          <Button asChild size="sm">
            <Link href="/auth/signin">
              Get Started for Free
            </Link>
          </Button>
          <Button variant="outline" asChild size="sm">
            <Link href="#features">
              See how it works
            </Link>
          </Button>
        </div>

        <p className="text-xs text-muted-foreground">
          No credit card required · First handyout free
        </p>
      </div>

      <div className="relative hidden h-full w-full overflow-hidden bg-neutral-100 lg:block">
        <img
          src={cdn("homepage/cta/cta.png")}
          alt="Handyout mobile handout preview"
          className="absolute inset-0 w-full h-full object-left object-cover"
        />
      </div>
    </div>
  );
};

export { PreFooter };
